/**
 * @generated SignedSource<<40d26183d620b075e1de39741be161f8>>
 * @relayHash 12fa8839bfb5b044352849438c33f8c9
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 12fa8839bfb5b044352849438c33f8c9

import { ConcreteRequest } from 'relay-runtime';
export type ImportCsvCapacityPlanInput = {
  file: any;
};
export type useImportCsvCapacityPlanMutation$variables = {
  input: ImportCsvCapacityPlanInput;
};
export type useImportCsvCapacityPlanMutation$data = {
  readonly importCsvCapacityPlan: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly errorMessage?: string;
      readonly message?: string;
    }> | null;
    readonly importCsvCapacityPlanResult: {
      readonly forecastFileUpload: {
        readonly uploadAt: string | null;
        readonly uploadBy: string | null;
      };
      readonly importedRows: number;
    } | null;
  };
};
export type useImportCsvCapacityPlanMutation = {
  response: useImportCsvCapacityPlanMutation$data;
  variables: useImportCsvCapacityPlanMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "importedRows",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uploadBy",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uploadAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v5/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "errorMessage",
          "storageKey": null
        }
      ],
      "type": "DataFormatNotSupported",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v5/*:: as any*/)
      ],
      "type": "Error",
      "abstractKey": "__isError"
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useImportCsvCapacityPlanMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ImportCsvCapacityPlanPayload",
        "kind": "LinkedField",
        "name": "importCsvCapacityPlan",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ImportCsvCapacityPlanResult",
            "kind": "LinkedField",
            "name": "importCsvCapacityPlanResult",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ForecastFileUpload",
                "kind": "LinkedField",
                "name": "forecastFileUpload",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useImportCsvCapacityPlanMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ImportCsvCapacityPlanPayload",
        "kind": "LinkedField",
        "name": "importCsvCapacityPlan",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ImportCsvCapacityPlanResult",
            "kind": "LinkedField",
            "name": "importCsvCapacityPlanResult",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ForecastFileUpload",
                "kind": "LinkedField",
                "name": "forecastFileUpload",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "12fa8839bfb5b044352849438c33f8c9",
    "metadata": {},
    "name": "useImportCsvCapacityPlanMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3f913989ba7470a272e2e1c4e94e1f68";

export default node;
